import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
//CSS
import "./Home.css";

//API
import { UploadRegistration } from "api/post/email";

// Assets
import { machineAssets, machineParts, CollectionAssets } from "../components/Asset_handler";
import TimerImage from "Assets/30sec_timer.png";
import espressoCup from "Assets/espresso_cup_in_hand.png";
import AIWorkflow from "Assets/AIWorkflow.png";

//components
import SwiperUp from "components/SwiperUp";
import Carousel from "components/Carousel";
import mira_in_home from "Assets/mira_in_home.png";
import CountdownTimer from "components/CountdownTimer";
import FadeInAnimation from "components/FadeInAnimation";
import PageWrapper from "components/PageWrapper";
import TypingEffect from "components/TypingEffect";
import colorful_machines from "Assets/colorful_machines.png";
import gradient_machines from "Assets/gradient_machines.png";

import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';


function Home() {
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.warn("Please enter an email address.", { position: "top-right", autoClose: 3000 });
      return;
    }

    await UploadRegistration(email);
    setEmail("");
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: "MIRA Espresso - AI-Powered Espresso Machine",
    image: machineAssets["machineSide"],
    description: "MIRA Espresso is the world's first AI-powered espresso machine, delivering barista-quality coffee with zero effort.",
    brand: {
      "@type": "Brand",
      name: "MIRA Espresso",
    },
    productStatus: "https://schema.org/PreSale",
    audience: {
      "@type": "Audience",
      audienceType: "Home Baristas, Coffee Enthusiasts, Professionals",
    },
    potentialAction: {
      "@type": "SubscribeAction",
      name: "Sign up for Early Access",
      target: {
        "@type": "EntryPoint",
        urlTemplate: "https://www.mira-espresso.com/early_access",
      },
    },
  };

  const slides = [
    {
      content: (
        <div className="designDetails">
          <div className="detailContainer">
            <div className="halfs">
              <div className="half">
                <img src={machineParts["drip_tray"]} alt="Mira Espresso Drip Tray" style={{ width: "100%" }} />
              </div>
              <div className="half">
                <h3 style={{ color: "white" }}>
                  A drip tray machined from a single piece of stainless steel. <br /> Spacious 1200ml capacity for effortless cleanup.
                </h3>
              </div>
            </div>
          </div>
        </div>
      ),
    },

    {
      content: (
        <div className="designDetails">
          <div className="detailContainer">
            <div className="halfs">
              <div className="half">
                <img src={machineParts["portafilter"]} alt="Mira Espresso Portafilter" style={{ width: "100%" }} />
              </div>
              <div className="half">
                <h3 style={{ color: "white" }}>
                  Stainless Steel Portafilter. <br /> Precision-engineered with finely engraved grip patterns and elegant chamfers.
                </h3>
              </div>
            </div>
          </div>
        </div>
      ),
    },
    {
      content: (
        <div className="designDetails">
          <div className="detailContainer">
            <div className="halfs">
              <div className="half">
                <img src={machineParts["water_bean_tank"]} alt="Mira Espresso Water and bean tank" style={{ width: "100%" }} />
              </div>
              <div className="half">
                <h3 style={{ color: "white" }}>
                  Glass Bean and Water Tank. <br /> Generous 1.5L capacity each for uninterrupted brewing.
                </h3>
              </div>
            </div>
          </div>
        </div>
      ),
    },
  ];

  const LLMText =
    "Espresso Beans, 70% Arabica, 30% Robusta<br /><br />Medium Roast, Brazil and Ethiopia<br /><br />Grind Size 300qm<br /><br />Brew Temparature 92°C<br /><br />Extraction Time 28s<br /><br />Pressure 9 Bars<br /><br />Pre-Infusion 3s<br /><br />Full Pressure 15s, drop to 4bar linearly.";

  return (
    <PageWrapper>
      <Helmet>
        <title>MIRA - The World’s First AI-Powered Espresso Machine</title>
        <meta name="description" content="MIRA Espresso is the world's first AI-powered espresso machine, delivering barista-quality coffee with zero effort." />
        <meta property="og:title" content="MIRA - The AI Espresso Revolution" />
        <meta property="og:description" content="MIRA analyzes your coffee beans and crafts the perfect espresso every time." />
        <meta property="og:image" content={machineAssets["machineFront"]} />
        <meta property="og:url" content="https://www.mira-espresso.com" />

        {/* JSON-LD Structured Data for Product in Development */}
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      </Helmet>
      <ToastContainer />
      <div>
        <div
          className="landingscreen"
          style={{
            backgroundImage: `url(${machineAssets["machineSide"]})`,
          }}
        >
          <FadeInAnimation delay={0}>
            <h1 className="mira_header">MIRA</h1>
          </FadeInAnimation>
          <FadeInAnimation delay={0.3}>
            <h3 className="mira_sub_header ">
              The world’s first <span style={{ color: "var(--color-accent)" }}>intelligent</span> <br />
              Espresso Machine.
            </h3>
          </FadeInAnimation>
        </div>
        <div className="sectionHeaderContainer fadeIn">
          <FadeInAnimation delay={0}>
            <h1>Meet MIRA.</h1>
            <h2>Your robot barista.</h2>
          </FadeInAnimation>
        </div>
        <div>
          <div className="swiperContainer  marginBetween">
            <div className="section section1">
              <FadeInAnimation delay={0}>
                <h3 className="h3-bold">Powered by AI</h3>
              </FadeInAnimation>
              <h3>
                <br />
                The first portafilter espresso machine that adapts to any coffee bean you throw its way.
              </h3>
              <div style={{ marginTop: "10%" }}>{/* <TypingEffect text={LLMText} typingSpeed={300} /> */}</div>
            </div>
            <div className="section section2">
              <img className="swiperImages" src={machineAssets["machineFrontLeft"]} alt="Mira Espresso image from the front" />
            </div>
            <div className="section section2"></div>
          </div>

          <div className="swiperContainer marginBetween">
            <div className="section section1" style={{ justifyContent: "center" }}>
              <h2>
                Grinder & <br /> Espresso Machine
              </h2>
              <h3>
                <br />
                Seamlessly integrated into one sleek, stainless steel body.
              </h3>
            </div>
            <div className="section section2">
              <img className="swiperImages" src={machineAssets["machineFrontTop"]} alt="Mira Espresso image at angle from the top" />
            </div>
          </div>
          <div
            className="swiperContainer"
            style={{
              backgroundImage: `url(${espressoCup})`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "bottom",
              margin: "0vh auto 0vh",
            }}
          >
            <div className="section section3">
              <h1>0:30</h1>
            </div>

            <div className="section section1 section1Resp">
              <h3 className="h3-bold">From 0 to 100 in 30 seconds.</h3>
              <h3>
                <br />
                MIRA advanced heating system delivers hot, delicious espresso in under 30 seconds.
              </h3>
            </div>
          </div>
        </div>
        <div className="sectionHeaderContainer">
          <div className="blockSectionHeader">
            <img style={{ width: "100%", marginTop: "5vh" }} src={gradient_machines} alt="siluet Mira Espresso" />
            <h2>
              Simplicity, but <br /> Barista Quality.
            </h2>
            <div>
              <h3>
              MIRA: the espresso machine that’s as smart as it is compact. Powered by advanced neural networks, MIRA analyses your coffee beans and crafts the perfect espresso every time. Sit back,
                enjoy your espresso, and let MIRA handle the tedious adjustments.
              </h3>
            </div>
          </div>
        </div>
        <div className="sectionHeaderContainer" style={{ backgroundColor: "var(--color-light-grey)" }}>
          <div>
            <h1>
              One Machine. <br /> One Purpose.
            </h1>
            <FadeInAnimation delay={0.3}>
              <h2>
                <span style={{ color: "var(--color-accent)" }}> Slim</span>,<span style={{ color: "var(--color-accent)" }}> Smart</span>,<span style={{ color: "var(--color-accent)" }}> Stylish</span>
              </h2>
            </FadeInAnimation>
          </div>
        </div>
        <div className="imagecontainer">
          <div className="imagebox">
            <FadeInAnimation direction="left" delay={0}>
              <img className="image-desktop imageSpacer" style={{ height: "75vh" }} src={machineAssets["machineBack"]} alt="Mira Espresso Back" />
            </FadeInAnimation>
            <FadeInAnimation direction="up" delay={0}>
              <img className="image-universal imageSpacer" style={{ height: "80vh" }} src={machineAssets["machineBackSide"]} alt="Mira Espresso Back Side" />
            </FadeInAnimation>
            <FadeInAnimation direction="right" delay={0}>
              <img className="image-desktop" style={{ height: "71vh" }} src={machineAssets["machineSide"]} alt="Mira Espresso Side" />
            </FadeInAnimation>
          </div>
          <div className="textBox">
            <FadeInAnimation delay={0.3}>
              <h4 className="h3-bold">No settings. No mess.</h4>
              <h4>
                Barista-quality espresso, effortless at home. No grind size adjustments, no temperature tweaks, no pressure settings—just pure simplicity. Place your cup beneath the portafilter, and
                MIRA does the rest. No buttons, no fuss—just good espresso in every cup.
              </h4>
            </FadeInAnimation>
          </div>
        </div>
        <div className="sectionHeaderContainer">
          <h1>
            <span style={{ color: "var(--color-accent)" }}>AI</span> Espresso. <br />
            How it works:
          </h1>
        </div>
        <div className="thirds">
          <div className="third">
            <FadeInAnimation delay={0}>
              <h1>1.</h1>
              <h4>
                <span className="h4-bold" style={{ color: "var(--color-accent)" }}>
                  Analyzing the Beans.
                </span>
                Snap a photo of your coffee. MIRA uses advanced AI - instantly identifies the origin, roast, and flavor profile of your beans, unlocking their full potential.
              </h4>
            </FadeInAnimation>
          </div>

          <div className="third">
            <FadeInAnimation delay={0.3}>
              <h1>2.</h1>
              <h4>
                <span className="h4-bold" style={{ color: "var(--color-accent)" }}>
                  AI Tailored Brewing.
                </span>
                MIRA customizes every step of the brewing process—temperature, grind size, pressure, and timing—to perfectly suit your beans and your taste.
              </h4>
            </FadeInAnimation>
          </div>

          <div className="third">
            <FadeInAnimation delay={0.6}>
              <h1>3.</h1>
              <h4>
                <span className="h4-bold" style={{ color: "var(--color-accent)" }}>
                  Always Learning.
                </span>
                Real-time sensors analyze each shot, refining every detail for future brews. With every cup, MIRA gets closer to espresso perfection.
              </h4>
            </FadeInAnimation>
          </div>
        </div>
        <div style={{ position: "relative", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <FadeInAnimation direction="up">
            <img
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                height: "100vh",
                overflow: "hidden",
                zIndex: 3,
              }}
              src={machineAssets["machineFront"]}
              alt="Machine Front"
            />
            <h1 className="miraFullWidth">MIRA</h1>
          </FadeInAnimation>
        </div>
        <div className="sectionHeaderContainer ">
          <div className="blockSectionHeader">
            <h1>Built to Last.</h1>

            <h3>
              MIRA Espresso is crafted from the finest, most durable materials. Stainless steel—a symbol of strength, beauty, and resistance to oxidation—forms the heart of its design. Designed to
              become timeless.
            </h3>
          </div>
        </div>
        {/* ////////////////////////////////// */}
        <Carousel slides={slides} />
        <div className="miraInHomeBox">
          <img className="miraInHomeImg" src={mira_in_home} alt="Mira Espresso on counter" style={{ width: "100%" }} />
        </div>

        <div className="miraMeasures">
          <div className="miraTextToLeft">
            <h2 className="leftText">Compact Footprint</h2>
            <h3 className="leftText2">
              With a base size of 17.5cm and 25.5cm, MIRA takes up significantly less space than most portafilter espresso and fully automatic machines. The average counter height is 60cm, so MIRA
              comfortably fits below.{" "}
            </h3>
          </div>
          <div className="miraCenteredContent">
            <img className="miraMeasuresImg" src={machineAssets["machineFront"]} alt="Machine Front" />
            <h1 className="belowText">17.5cm</h1>
          </div>
          <div className="miraTextToRight">
            <h1 className="belowText">54.2cm</h1>
          </div>
        </div>

        <div className="partsContainer">
          <FadeInAnimation delay={0}>
            <div className="nonRestictedContainer">
              <h1 style={{ color: "white" }}>
                The <span style={{ color: "var(--color-accent)" }}>Perfect</span> Shot
              </h1>
              <h1 style={{ color: "white", textAlign: "right" }}>
                of <span style={{ color: "var(--color-accent)" }}>Espresso</span>.
              </h1>

              <h2 style={{ color: "var(--color-text-grey)", textAlign: "left" }}>comes from great parts!</h2>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  padding: "0vh",
                  borderTop: "0.2px solid var(--color-text-grey)",
                }}
              >
                <div
                  className="centerAllItemsVertically centerAllItemsHorizontally"
                  style={{
                    borderRight: "0.2px solid var(--color-text-grey)",
                    padding: "10% 10% 10% 10%",
                  }}
                >
                  <h3 style={{ textAlign: "left", color: "var(--color-text-grey)" }}>
                    MIRA’s built-in grinder features premium espresso burrs, delivering exceptional grinding performance with unmatched consistency. Designed with{" "}
                    <span style={{ color: "white" }}>all-round burrs</span>, it offers the ultimate flexibility to perfect any coffee you desire.
                  </h3>
                </div>
                <div className="centerAllItemsVertically centerAllItemsHorizontally partBoxSize">
                  <img className="partImages" src={machineParts["burrs"]} alt="Mira Espresso Parts Espresso Burrs" />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  padding: "0vh",
                  borderTop: "0.2px solid var(--color-text-grey)",
                }}
              >
                <div className="centerAllItemsVertically centerAllItemsHorizontally partBoxSize">
                  <img className="partImages" src={machineParts["piston"]} alt="Mira Espresso Piston for Pump" />
                </div>
                <div
                  className="centerAllItemsVertically centerAllItemsHorizontally"
                  style={{
                    borderLeft: "0.2px solid var(--color-text-grey)",
                    padding: "10% 10% 10% 10%",
                  }}
                >
                  <h3 style={{ textAlign: "left", color: "var(--color-text-grey)" }}>
                    Espresso is all about pressure. MIRA is high-quality <span style={{ color: "white" }}>piston pump</span> delivers a consistent 9 bars of pressure, every time. Unlike vibration or
                    rotary pumps, the piston pump ensures flawless stability with no pressure fluctuations.
                  </h3>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  padding: "0vh",
                  borderTop: "0.2px solid var(--color-text-grey)",
                }}
              >
                <div
                  className="centerAllItemsVertically centerAllItemsHorizontally"
                  style={{
                    borderRight: "0.2px solid var(--color-text-grey)",
                    padding: "10% 10% 10% 10%",
                  }}
                >
                  <h3 style={{ textAlign: "left", color: "var(--color-text-grey)" }}>
                    <span style={{ color: "white" }}>Pre-Breaking Technology</span> ensures a more uniform grind for your espresso beans, enhancing flavor extraction. The result? A richer, more
                    nuanced espresso with exciting and complex flavors in every cup.
                  </h3>
                </div>
                <div className="centerAllItemsVertically centerAllItemsHorizontally partBoxSize">
                  <img className="partImages" src={machineParts["auger"]} alt="Mira Espresso Parts: Auger" />
                </div>
              </div>
            </div>
          </FadeInAnimation>
        </div>
        <div className="getTheDetails">
          <FadeInAnimation direction="left" delay={0}>
            <img className="detailImg1" src={machineAssets["machineSideCut"]} alt="Mira Espresso Side" />
          </FadeInAnimation>
          <h1 className="textTransform">
            Details <br /> wherever you look.
          </h1>
          <div className="miraTextTransform">
            <h1 className="miraFullWidth" style={{ transform: "translateY(20vh)", color: "white" }}>
              MIRA
            </h1>
          </div>
          <FadeInAnimation direction="up" delay={0}>
            <img className="detailImg2" src={machineAssets["machineBack"]} alt="Mira Espresso Back" />
          </FadeInAnimation>
        </div>
        <div className="sectionHeaderContainer newsletterSection">
          <div className="newsletterContent">
            <h1 className="newsletterHeader">Join the Revolution.</h1>
            <h2 className="newsletterSubheader">Interested? Stay up to date on progress and launch date.</h2>
            <form onSubmit={handleSubmit} className="newsletterForm">
              <div className="inputGroup">
                <input type="email" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)} className="newsletterInput" />
                <button type="submit" className="newsletterButton">
                  Get Early Access
                </button>
              </div>
            </form>
            <p className="disclaimer">We respect your privacy. Your email address is only used for updates regarding MIRA.</p>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

export default Home;
